import { useMemo } from 'react'
import cn from 'classnames'

import { ContentSteps, useStepFlow } from 'src/lib/useStepFlow'

import { FirstStep, FourthStep, SecondStep, ThirdStep } from './ui/steps'

import Logo from '../../icons/logo.webp'

import {
    TextHeaderEn as FirstEn,
    TextHeaderDe as FirstDe,
    TextHeaderEs as FirstEs,
    TextHeaderRo as FirstRo,
    TextHeaderFr as FirstFr,
    TextHeaderIt as FirstIt,
    TextHeaderPt as FirstPt,
    TextHeaderEl as FirstEl,
    TextHeaderSl as FirstSl,
} from './ui/steps/first-step/text-first-step'
import {
    TextHeaderEn as SecondEn,
    TextHeaderDe as SecondDe,
    TextHeaderEs as SecondEs,
    TextHeaderRo as SecondRo,
    TextHeaderFr as SecondFr,
    TextHeaderIt as SecondIt,
    TextHeaderPt as SecondPt,
    TextHeaderEl as SecondEl,
    TextHeaderSl as SecondSl,
} from './ui/steps/second-step/text-second-step'
import {
    TextHeaderEn as ThirdEn,
    TextHeaderDe as ThirdDe,
    TextHeaderEs as ThirdEs,
    TextHeaderRo as ThirdRo,
    TextHeaderFr as ThirdFr,
    TextHeaderIt as ThirdIt,
    TextHeaderPt as ThirdPt,
    TextHeaderEl as ThirdEl,
    TextHeaderSl as ThirdSl,
} from './ui/steps/third-step/text-third-step'
import {
    TextHeaderEn as FourthEn,
    TextHeaderDe as FourthDe,
    TextHeaderEs as FourthEs,
    TextHeaderRo as FourthRo,
    TextHeaderFr as FourthFr,
    TextHeaderIt as FourthIt,
    TextHeaderPt as FourthPt,
    TextHeaderEl as FourthEl,
    TextHeaderSl as FourthSl,
} from './ui/steps/fourth-step/text-fourth-step'

import styles from './styles.module.scss'
import { normalizeBrowserLang, TLang } from 'src/constants/langs'

const stepComponents = {
    [ContentSteps.FIRST]: FirstStep,
    [ContentSteps.SECOND]: SecondStep,
    [ContentSteps.THIRD]: ThirdStep,
    [ContentSteps.FOURTH]: FourthStep,
}

const textHeaderMap = {
    FIRST: {
        en: FirstEn,
        de: FirstDe,
        es: FirstEs,
        ro: FirstRo,
        fr: FirstFr,
        it: FirstIt,
        pt: FirstPt,
        el: FirstEl,
        sl: FirstSl,
    },
    SECOND: {
        en: SecondEn,
        de: SecondDe,
        es: SecondEs,
        ro: SecondRo,
        fr: SecondFr,
        it: SecondIt,
        pt: SecondPt,
        el: SecondEl,
        sl: SecondSl,
    },
    THIRD: {
        en: ThirdEn,
        de: ThirdDe,
        es: ThirdEs,
        ro: ThirdRo,
        fr: ThirdFr,
        it: ThirdIt,
        pt: ThirdPt,
        el: ThirdEl,
        sl: ThirdSl,
    },
    FOURTH: {
        en: FourthEn,
        de: FourthDe,
        es: FourthEs,
        ro: FourthRo,
        fr: FourthFr,
        it: FourthIt,
        pt: FourthPt,
        el: FourthEl,
        sl: FourthSl,
    },
} as const

const Chicken = () => {
    const { step, goToNextStep } = useStepFlow()
    const StepComponent = stepComponents[step]

    const currentLang = useMemo<TLang>(() => {
        const nav = typeof navigator !== 'undefined' ? navigator.language : 'en'
        return normalizeBrowserLang(nav)
    }, [])

    const HeaderComponent = textHeaderMap[step]?.[currentLang] ?? null

    return (
        <div
            className={cn(
                styles.root,
                styles[`root__${step}__${currentLang}`],
                {
                    [styles[`root--${currentLang}`]]:
                        currentLang === 'fr' || currentLang === 'el',
                },
            )}
        >
            {(step === ContentSteps.SECOND || step === ContentSteps.FOURTH) && (
                <div className={styles.root__blur} />
            )}
            <img src={Logo} alt="Logo" className={styles.logo_wrapper} />

            <div
                className={cn(styles.header_text_wrapper, {
                    [styles.header_text_wrapper__blur]:
                        step === ContentSteps.SECOND,
                })}
            >
                {HeaderComponent && <HeaderComponent />}
            </div>

            <StepComponent
                onNext={goToNextStep}
                step={step}
                lang={currentLang}
            />
        </div>
    )
}

export default Chicken
